import React, { useState } from "react";
import {
  Button,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Card,
  CardContent,
  Grid,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

//code test for ram
const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
  },
  title: {
    fontSize: 18,
    fontWeight: theme.typography.fontWeightMedium,
  },
  content: {
    marginTop: theme.spacing(1),
  },
  money: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.secondary.main,
  },
  status: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    "& > div": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  },
  editButton: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  dialog: {
    padding: theme.spacing(3),
  },
}));
const CustomBindDashboard = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [insuranceCompanies] = useState([
    {
      id: "1",
      name: "Company A",
      splits: { quotey: 30, brokers: 40, insurance: 30 },
      customPDFs: 120,
      financials: {
        total: 10000,
        quotey: 3000,
        brokers: 4000,
        insurance: 3000,
      },
      status: { pending: 20, paid: 90, inProcess: 10 },
    },
    {
      id: "2",
      name: "Company B",
      splits: { quotey: 25, brokers: 50, insurance: 25 },
      customPDFs: 150,
      financials: {
        total: 15000,
        quotey: 3750,
        brokers: 7500,
        insurance: 3750,
      },
      status: { pending: 30, paid: 100, inProcess: 20 },
    },
  ]);

  const handleClickOpen = (company) => {
    setSelectedCompany(company);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    console.log("Saving data for:", selectedCompany);
    handleClose();
  };
  const formatCurrency = (amount) => {
    // Format as currency, e.g., $10,000
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };
  return (
    <div className={classes.root}>
      <Typography variant="h4" gutterBottom>
        Custom Bind Dashboard
      </Typography>
      <Grid container spacing={2}>
        {insuranceCompanies.map((company) => (
          <Grid item xs={12} md={6} lg={4} key={company.id}>
            <Card className={classes.card} variant="outlined">
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {company.name}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Custom PDFs: {company.customPDFs}
                </Typography>
                <Typography variant="body2" className={classes.money}>
                  Total: {formatCurrency(company.financials.total)}
                </Typography>
                <Typography variant="body2">
                  Quotey: {formatCurrency(company.financials.quotey)}
                </Typography>
                <Typography variant="body2">
                  Brokers: {formatCurrency(company.financials.brokers)}
                </Typography>
                <Typography variant="body2">
                  Insurance: {formatCurrency(company.financials.insurance)}
                </Typography>
                <Box marginTop={2} className={classes.status}>
                  <Typography variant="body2" color="textSecondary">
                    Pending: {company.status.pending}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Paid: {company.status.paid}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    In Process: {company.status.inProcess}
                  </Typography>
                </Box>
                <Box marginTop={2} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleClickOpen(company)}
                  >
                    Edit
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Edit Payment Splits</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="subtitle1">
            Custom PDFs: {selectedCompany.customPDFs}
          </Typography>
          {Object.entries(selectedCompany.financials || {}).map(
            ([key, value]) => (
              <TextField
                key={key}
                margin="dense"
                id={key}
                label={`${key.charAt(0).toUpperCase() + key.slice(1)} ($)`}
                type="number"
                fullWidth
                value={value || ""}
                onChange={(e) =>
                  setSelectedCompany({
                    ...selectedCompany,
                    financials: {
                      ...selectedCompany.financials,
                      [key]: parseInt(e.target.value),
                    },
                  })
                }
              />
            )
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CustomBindDashboard;
